import { Spin } from 'antd';
import React from 'react';
import styles from './FallbackSpin.module.css';

const FallbackSpin: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <Spin />
    </div>
  );
};

export default FallbackSpin;
